import { render, staticRenderFns } from "./ServicesEditDialog.vue?vue&type=template&id=89f45c3c&scoped=true"
import script from "./ServicesEditDialog.vue?vue&type=script&lang=js"
export * from "./ServicesEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ServicesEditDialog.vue?vue&type=style&index=0&id=89f45c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f45c3c",
  null
  
)

export default component.exports